import embed from './modules/embed.js';

embed();
